import { FC } from 'react';
// components
import AddSubProductType from 'components/main/SubProductType/Add';

const AddSubProductTypes: FC = () => <AddSubProductType />;

export default AddSubProductTypes;
